<div class="ds-wrap">
  <label class="ds-label" for="doctorSearch">Find a doctor</label>

  <div class="ds-group">
    <input id="doctorSearch" type="text" autocomplete="off" role="combobox"
           aria-controls="ds-list" aria-autocomplete="list" [attr.aria-expanded]="open"
           placeholder="Search by doctor name or code (e.g. DR-DUADX8)"
           [ngModel]="query" (ngModelChange)="onQueryChange($event)"
           (keydown)="onKeydown($event)" (focus)="onFocus()" />
    <button type="button" class="ds-btn" (click)="searchNow()">Search</button>
  </div>

  <div class="ds-panel" id="ds-list" role="listbox" *ngIf="open">

    <div class="ds-state" *ngIf="loading">Searching…</div>
    <div class="ds-state" *ngIf="!loading && selecting">Opening doctor…</div>

    <!-- API error -->
    <div class="ds-empty" *ngIf="!loading && !selecting && error">
      <span class="ds-empty-icon" aria-hidden="true">!</span>
      <div>
        <div class="ds-empty-title">Couldn’t load doctors right now</div>
        <div class="ds-empty-sub">Please try again in a moment.</div>
      </div>
    </div>

    <!-- Doctor not found -->
    <div class="ds-empty" *ngIf="!loading && !selecting && !error && results.length === 0">
      <span class="ds-empty-icon" aria-hidden="true">!</span>
      <div>
        <div class="ds-empty-title">No doctors found for “{{ query.trim() }}”</div>
        <div class="ds-empty-sub">Check the spelling, or try the doctor code (e.g. DR-DUADX8).</div>
      </div>
    </div>

    <!-- Results (by name → several rows, by full code → one row) -->
    <ng-container *ngIf="!loading && !selecting && !error && results.length > 0">
      <div class="ds-heading">{{ results.length > 1 ? 'DOCTORS' : 'DOCTOR' }}</div>
      <div class="ds-row" role="option" *ngFor="let d of results; let i = index"
           [class.active]="i === activeIndex" [attr.aria-selected]="i === activeIndex"
           (mousedown)="$event.preventDefault()" (click)="select(d)" (mouseenter)="activeIndex = i">
        <img *ngIf="d.profilepic_url" class="ds-av ds-av-img" [src]="d.profilepic_url" [alt]="d.name" />
        <div *ngIf="!d.profilepic_url" class="ds-av">{{ initials(d.name) }}</div>
        <div class="ds-info">
          <div class="ds-name">
            <ng-container *ngFor="let p of parts(d.name)"><mark *ngIf="p.m; else plain">{{ p.t }}</mark><ng-template #plain>{{ p.t }}</ng-template></ng-container>
          </div>
          <div class="ds-sub">{{ d.specialty }}<span *ngIf="d.specialty && d.hospital"> · </span>{{ d.hospital }}</div>
        </div>
        <span class="ds-code">
          <ng-container *ngFor="let p of parts(d.doctor_code)"><mark *ngIf="p.m; else plainC">{{ p.t }}</mark><ng-template #plainC>{{ p.t }}</ng-template></ng-container>
        </span>
      </div>
      <div class="ds-footer" *ngIf="results.length > 1"><span>{{ results.length }} matches</span></div>
    </ng-container>
  </div>
</div>